/**
 * @fileoverview POST handler for the "/engagement/webhook_templates/update_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementWebhookTemplatesUpdateTagsCacheKeys } from "./constants";
import type {
  PostEngagementWebhookTemplatesUpdateTagsProps,
  EngagementWebhookTemplatesUpdateTagsResult,
} from "./types";

export const postEngagementWebhookTemplatesUpdateTags = reactQueryMutationAdapter(
  engagementWebhookTemplatesUpdateTagsCacheKeys,
  (props: PostEngagementWebhookTemplatesUpdateTagsProps): Promise<EngagementWebhookTemplatesUpdateTagsResult> => {
    return fetch("/engagement/webhook_templates/update_tags", "POST", props);
  }
);
